function n(n){return null!=n&&!(Array.isArray(n)&&0===n.length)}function r(r,t=!1){return r&&(n(r.value)&&""!==r.value||t&&n(r.defaultValue)&&""!==r.defaultValue)}function t(n){return n.startAdornment}export{t as a,r as i};
